import _objectWithoutProperties from "/drone/src/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["className"];
import React, { forwardRef } from 'react';
import { useFilterViewerClassNames } from './hooks/useFilterViewerClassNames';
import { useFilterViewer } from './hooks/useFilterViewer';
import { FilterViewConditions, FilterViewerActions, FilterViewerRoot, FilterViewerTopBar, FilterViewerAddFilterHint, FilterViewerTopBarSummary } from './style';
import { FILTER_VIEWER_CLASS_PREFIX } from './constants';
import { useComponentTheme } from '../../../utils/hooks';
import { Typography } from '../../Typography';
import { ContextMenu } from '../../ContextMenu';
import { Link } from '../../Link';
import { Button } from '../../Button';
import { pluralize } from '../../../system/util/pluralize';
import { ConditionTag } from '../../ConditionTag';
export var FilterViewer = forwardRef(function FilterViewer(_ref, ref) {
  var className = _ref.className,
      props = _objectWithoutProperties(_ref, _excluded);

  var theme = useComponentTheme(FILTER_VIEWER_CLASS_PREFIX);
  var classNames = useFilterViewerClassNames(FILTER_VIEWER_CLASS_PREFIX, className);

  var _useFilterViewer = useFilterViewer(props, ref),
      rootProps = _useFilterViewer.rootProps,
      getOpenFilterButtonProps = _useFilterViewer.getOpenFilterButtonProps,
      getEditFilterButtonProps = _useFilterViewer.getEditFilterButtonProps,
      clearFilterButtonProps = _useFilterViewer.clearFilterButtonProps,
      confirmationDialogProps = _useFilterViewer.confirmationDialogProps,
      clearFilterCancelButtonProps = _useFilterViewer.clearFilterCancelButtonProps,
      clearFilterConfirmButtonProps = _useFilterViewer.clearFilterConfirmButtonProps,
      getTagProps = _useFilterViewer.getTagProps,
      rootConditionsCount = _useFilterViewer.rootConditionsCount,
      showSelectedFilter = _useFilterViewer.showSelectedFilter,
      showResultCount = _useFilterViewer.showResultCount,
      showResultTotalCount = _useFilterViewer.showResultTotalCount,
      schema = _useFilterViewer.schema,
      isConditionValueEmpty = _useFilterViewer.isConditionValueEmpty,
      showAddFilterButton = _useFilterViewer.showAddFilterButton,
      showAddFilterHint = _useFilterViewer.showAddFilterHint,
      resultCountFormatted = _useFilterViewer.resultCountFormatted,
      resultTotalCountFormatted = _useFilterViewer.resultTotalCountFormatted;

  return React.createElement(FilterViewerRoot, Object.assign({}, rootProps, {
    theme: theme,
    className: classNames.Root
  }), showAddFilterButton && React.createElement(Button, Object.assign({
    secondary: true
  }, getOpenFilterButtonProps(), {
    className: classNames.AddFiltersButton
  }), "Add filters"), showAddFilterHint && React.createElement(FilterViewerAddFilterHint, {
    theme: theme,
    className: classNames.AddFilterHint
  }, "Add your filter to refine the results"), showSelectedFilter && React.createElement(React.Fragment, null, React.createElement(FilterViewerTopBar, {
    theme: theme,
    className: classNames.TopBar
  }, React.createElement(FilterViewerTopBarSummary, {
    theme: theme,
    className: classNames.TopBarSummary
  }, React.createElement(Typography, {
    sectionTitle: true,
    tag: "span",
    className: classNames.TopBarTitle
  }, "Applied ", rootConditionsCount, ' ', pluralize(rootConditionsCount, 'filter', 'filters')), showResultCount && React.createElement(Typography, {
    paragraph: true,
    medium: true,
    tag: "span",
    className: classNames.TopBarResultCount,
    marginLeft: 6
  }, "showing ", resultCountFormatted, ' ', showResultTotalCount ? "out of ".concat(resultTotalCountFormatted) : '', ' ', "results")), React.createElement(FilterViewerActions, {
    theme: theme,
    className: classNames.Actions
  }, React.createElement(Link, Object.assign({}, getEditFilterButtonProps(), {
    className: classNames.EditFiltersButton
  }), "Edit filters"), React.createElement(ContextMenu, Object.assign({
    trigger: React.createElement(Link, Object.assign({}, clearFilterButtonProps, {
      className: classNames.ClearFiltersButton
    }), "Clear all"),
    paddingY: 6,
    paddingX: 4.5,
    width: 62.5,
    className: classNames.ClearFiltersConfirmation
  }, confirmationDialogProps), React.createElement(Typography, {
    label: true,
    medium: true,
    className: classNames.ClearFiltersConfirmationTitle
  }, "Clear your filters"), React.createElement(Typography, {
    paragraph: true,
    medium: true,
    tag: "div",
    marginTop: 1.5,
    marginBottom: 6,
    className: classNames.ClearFiltersConfirmationDescription
  }, "This will remove all your applied filters. Are you sure?"), React.createElement(Button, Object.assign({
    tertiary: true,
    marginRight: 1,
    className: classNames.ClearFiltersConfirmationCancelButton
  }, clearFilterCancelButtonProps), "Cancel"), React.createElement(Button, Object.assign({
    primary: true,
    danger: true,
    className: classNames.ClearFiltersConfirmationConfirmButton
  }, clearFilterConfirmButtonProps), "Yes, Clear it")))), React.createElement(FilterViewConditions, {
    theme: theme,
    className: classNames.Conditions
  }, schema.conditions.map(function (condition) {
    if (!condition.id) {
      return null;
    }

    var path = condition.name || condition.id;

    if (isConditionValueEmpty(condition, path)) {
      return null;
    }

    return React.createElement(ConditionTag, Object.assign({}, getTagProps(condition, path), {
      key: condition.name || condition.id,
      marginBottom: 2,
      marginRight: 2
    }));
  }))));
});
FilterViewer.defaultProps = {};